/**
 * sg-variant-link.js
 * Aggiorna i link della product card (immagine + titolo + "Seleziona opzioni")
 * con ?variant=<id> quando l'utente clicca uno swatch colore.
 *
 * Funziona intercettando l'evento 'click' sui div .product__color-swatches--js
 * leggendo la variantData già presente nel <script type="application/json">
 * dentro <variant-radios>.
 */

(function () {
  'use strict';

  /**
   * Dato un elemento swatch cliccato e il suo <variant-radios>,
   * trova la variante corrispondente e aggiorna tutti i link della card.
   */
  function updateCardLinks(swatchEl, radiosEl) {
    // Variante corrente già calcolata dal tema (dopo il suo click handler)
    // La leggiamo dalla proprietà currentVariant impostata da VariantRadios
    // ma quel valore è sincrono → usiamo setTimeout(0) per aspettare il suo handler
    setTimeout(function () {
      var productCard = swatchEl.closest('.product-item');
      if (!productCard) return;

      // Recupera variantData dal <script> dentro variant-radios
      var jsonScript = radiosEl.querySelector('script[type="application/json"]');
      if (!jsonScript) return;

      var variants;
      try {
        variants = JSON.parse(jsonScript.textContent);
      } catch (e) {
        return;
      }

      // Leggi tutti gli swatch attivi per ricostruire le options selezionate
      var activeSwatches = productCard.querySelectorAll(
        '.product__color-swatches--js.active'
      );
      var selectedOptions = Array.from(activeSwatches).map(function (el) {
        return el.getAttribute('data-value');
      });

      if (!selectedOptions.length) return;

      // Trova la variante che corrisponde alle options selezionate
      var matchedVariant = null;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = selectedOptions.every(function (opt, idx) {
          return v.options[idx] === opt;
        });
        // Se non tutte le opzioni sono selezionate (es. solo colore),
        // basta che la prima opzione corrisponda
        if (!match && selectedOptions.length === 1) {
          match = v.options.some(function (opt) {
            return opt === selectedOptions[0];
          });
        }
        if (match) {
          matchedVariant = v;
          break;
        }
      }

      if (!matchedVariant) return;

      var variantId = matchedVariant.id;

      // Aggiorna tutti gli <a> della card che portano alla pagina prodotto
      var links = productCard.querySelectorAll(
        'a.product__media, a.product-item__name, a.product-item__select-options'
      );
      links.forEach(function (link) {
        var href = link.getAttribute('href');
        if (!href) return;
        // Rimuovi eventuale ?variant= precedente
        href = href.split('?')[0];
        link.setAttribute('href', href + '?variant=' + variantId);
      });

      // Aggiorna anche il data-url dei custom element <select-option>
      var selectOptions = productCard.querySelectorAll('select-option');
      selectOptions.forEach(function (el) {
        var url = el.getAttribute('data-url');
        if (!url) return;
        // Mantieni il ?section_id= ma aggiungi &variant=
        if (url.indexOf('variant=') !== -1) {
          url = url.replace(/variant=\d+/, 'variant=' + variantId);
        } else if (url.indexOf('?') !== -1) {
          url = url + '&variant=' + variantId;
        } else {
          url = url + '?variant=' + variantId;
        }
        el.setAttribute('data-url', url);
      });

    }, 0);
  }

  /**
   * Attacca il listener a un singolo <variant-radios>
   */
  function attachToRadios(radiosEl) {
    if (radiosEl.__sgVariantLinkAttached) return;
    radiosEl.__sgVariantLinkAttached = true;

    radiosEl.addEventListener('click', function (e) {
      var swatch = e.target.closest('.product__color-swatches--js');
      if (!swatch) return;
      updateCardLinks(swatch, radiosEl);
    });
  }

  /**
   * Scansiona tutto il documento alla ricerca di <variant-radios>
   * e attacca il listener. Usa MutationObserver per le card inserite
   * dinamicamente (es. caroselli lazy).
   */
  function init() {
    document.querySelectorAll('variant-radios').forEach(attachToRadios);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.tagName && node.tagName.toLowerCase() === 'variant-radios') {
            attachToRadios(node);
          }
          node.querySelectorAll &&
            node.querySelectorAll('variant-radios').forEach(attachToRadios);
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
